/* RESPONSIBLE TEAM: team-standalone */
import BaseValidator from 'ember-cp-validations/validators/base';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';
import type FinStandaloneService from 'embercom/services/fin-standalone-service';
import type IntlService from 'ember-intl/services/intl';
import type Store from '@ember-data/store';
import type StandardizedPlatform from 'embercom/objects/standalone/platforms/standardized-platform';
import {
  getValidatedPlatform,
  isFieldUnavailableInProduction,
} from 'embercom/validators/standalone/field-availability-utils';

interface PredicateNode {
  attribute?: string;
  predicates?: { length: number; objectAt(index: number): PredicateNode };
}

export default class PredicateFieldsAvailableInProduction extends BaseValidator {
  @service declare appService: AppService;
  @service declare finStandaloneService: FinStandaloneService;
  @service declare intl: IntlService;
  @service declare store: Store;

  validate(predicateGroup: PredicateNode | undefined, options: { messageKey: string }) {
    let platform = getValidatedPlatform(this.appService, this.finStandaloneService);
    if (!platform) {
      return true;
    }

    if (!predicateGroup?.predicates) {
      return true;
    }

    for (let i = 0; i < predicateGroup.predicates.length; i++) {
      let predicate = predicateGroup.predicates.objectAt(i);
      if (this.hasUnavailableField(predicate, platform)) {
        return this.intl.t(options.messageKey);
      }
    }

    return true;
  }

  private hasUnavailableField(predicate: PredicateNode, platform: StandardizedPlatform): boolean {
    if (predicate.predicates?.length) {
      for (let i = 0; i < predicate.predicates.length; i++) {
        let nested = predicate.predicates.objectAt(i);
        if (this.hasUnavailableField(nested, platform)) {
          return true;
        }
      }
    }

    let attribute = predicate.attribute;
    if (!attribute) {
      return false;
    }

    return isFieldUnavailableInProduction(attribute, platform, this.store);
  }

  static getDependentsFor() {
    return [];
  }
}
